export default __webpack_public_path__ + "static/remotenetwork-7a8c5168c54cf959d18ea96dce9b9dd8.png";